@if (csvTemplate) {
  <mat-nav-list>
    <h2>
      {{
        translationService.getTemplateNameFieldsText(csvTemplate.templateName)
      }}
    </h2>

    @for (field of fields; track field; let i = $index; let last = $last) {
      <a
        mat-list-item
        (keydown)="onKeydown($event, i)"
        [attr.tabindex]="i === 0 ? 0 : -1"
      >
        <span matListItemTitle>
          <span class="bold"
            >{{ translationService.getSystemFieldText() }}:</span
          >
          {{ field.systemField }}
        </span>

        <span matListItemTitle>
          <span class="bold"
            >{{ translationService.getUserDefinedFieldText() }}:</span
          >
          {{ field.alias }}
        </span>
      </a>

      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </mat-nav-list>
}
